// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database"; // ✅ RTDB

const firebaseConfig = {
  apiKey: "AIzaSyBXj7P9TapEg86R_VNKVLJzNxMFonr86Xg",
  authDomain: "college-bus-tracker-562e0.firebaseapp.com",
  projectId: "college-bus-tracker-562e0",
  storageBucket: "college-bus-tracker-562e0.appspot.com",
  messagingSenderId: "592751082335",
  appId: "1:592751082335:web:3e3fae2940e8930de314ea",
  measurementId: "G-P6FH17DZ60",

  // ✅ Realtime Database URL (NO trailing slash)
  databaseURL:
    "https://college-bus-tracker-562e0-default-rtdb.asia-southeast1.firebasedatabase.app",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ LIVE location only (RTDB)
export const rtdb = getDatabase(app, firebaseConfig.databaseURL);